import React, { Component } from 'react';
import InputWithClear from '../../../../Elements/InputComponents/InputWithClear';
import mathHelper from '../../../../Helpers/mathHelper';

class BaseCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bodyactive: true,
      noteActive: false,
    };
    this.renderInputField = this.renderInputField.bind(this);
  }

  changeBodyStatus = () => {
    this.setState({ bodyactive: !this.state.bodyactive });
  };

  Currency = () => {
    return 'CurrencyCode';
  };

  MoneyFields = [
    'RevenuePerCycle',
    'RevenueAnnually',
    'RecruitingCostTotal',
    'EvalFeePerCycle',
    'BankChargesAnnually',
    'EvalBonusAnnually',
    'EvalFeeAnnually',
    'ClientFeePerCycle',
    'ClientFeeAnnually',
    'ClientFeePerCycleTotal',
    'ClientRevenueTotal',
    'MarkedUpAnnually',
    'MarkedUpFeePerCycle',
    'MarkedUpFeePerEval',
    'MarkedUpRevenueTotal',
    'MarkedUpRevenuePerCycleTotal',
    'ExtDataCheckAnnually',
    'TransCostAnnually',
    'EditorCostAnnually',
    'EditingCostTotal',
    'EditorCostPerCycle',
    'TransCostPerCycle',
    'ExtDataCheckPerCycle',
    'EmployeeCostPerCycle',
    'EmployeeCostSubTotal',
    'PayrollTaxPerCycle',
    'PayrollTaxAnnually',
    'EmpBenefitsPerCycle',
    'EmpBenefitsAnnually',
    'CommissionPerCycle',
    'CommissionAnnually',
    'EmployeeCostTotal',
    'OtherCostTotal',
    'OverheadRateAnnually',
    'ICRFeeCostAnnually',
    'ICRFeeCostPerCycle',
    'ICRFeeCostPerEval',
    'IVRFeeCostAnnually',
    'IVRFeeCostPerCycle',
    'IVRFeeCostPerEval',
    'VocazillaCostAnnually',
    'VocazillaCostPerCycle',
    'VocazillaCostPerEval',
    'SMCostAnnually',
    'SMCostPerCycle',
    'SMCostPerEval',

    'EditorCostPerHourConv',
    'VideoEditorCostPerEval',
    'VideoEditorCostPerCycle',
    'VideoEditorCostAnnually',
    'TimeCaptureCostPerHourConv',
    'TimeCaptureCostPerEval',
    'TimeCaptureCostPerCycle',
    'TimeCaptureCostAnnually',
    'ShippingCostPerEvalConv',
    'ShippingCostPerCycle',
    'ShippingCostAnnually',
    'CardCostPerEvalConv',
    'CardCostPerCycle',
    'CardCostAnnually',
    'StreamingCostPerHourConv',
    'StreamingCostPerEval',
    'StreamingCostPerCycle',
    'StreamingCostAnnually',
    'CDRCostPerCycle',
    'CDRCostAnnually',
    'DVDCostPerCycle',
    'DVDCostAnnually',
    'VideoCaseCostPerCycle',
    'VideoCaseCostAnnually',
    'MailingCostPerEval',
    'MailingCostPerCycle',
    'MailingCostAnnually',
    'DNECostPerCycle',
    'DNECostAnnually',
    'VideoCostTotal',

    'OwningOfficeNetRevenueAnnually',
    'OwningOfficeNetRevenuePerCycle',
    'FieldworkOfficeNetRevenueAnnually',
    'FieldworkOfficeNetRevenuePerCycle',
    'FieldworkOfficeCostAnnually',
    'FieldworkOfficeCostPerCycle',
    'ClientFeePerCycleTotal',
    'ClientRevenueTotal',
    'DeferredCostAnnually',
    'DeferredCostPerCycle',
    'CostAnnually',
    'CostPerCycle',
    'RevenueAnnually',
    'RevenuePerCycle',
    'TravelCostAnnuallyTotal',
    'TravelCostAnnually',
    'AnnualMiscCostPerCycle1',
    'AnnualMiscCostPerCycle2',
    'AnnualMiscCostPerCycle3',
    'TeamLeadSalaryPerCycle',
    'TeamLeadSalaryAnnually',
    'OperationsMgrSalaryPerCycle',
    'OperationsMgrSalaryAnnually',
    'AssistantProjMgrSalaryPerCycle',
    'AssistantProjMgrSalaryAnnually',
    'PanelMgrRecruiterSalaryPerCycle',
    'PanelMgrRecruiterSalaryAnnually',
    'EditDataCheckSalaryPerCycle',
    'EditDataCheckSalaryAnnually',
    'SMCostPerEvalConv',
    'VocazillaCostPerEvalConv',
    'ProjMgrSalaryAnnually',
    'ProjMgrSalaryPerCycle',
    'IVRFeeCostPerEvalConv',
    'ICRFeeCostPerEvalConv',
  ];

  renderInputField(
    fieldName,
    labelText,
    colwidth,
    type,
    validityCheckerFunction,
    index,
    disabled = false,
    selectValues = [],
    dropDownValues = [],
    inputClass = '',
    fieldType = ''
  ) {
    if (this.Editable()) {
      disabled = true;
    }
    return (
      <InputWithClear
        fieldName={fieldName}
        labelText={labelText === '' ? fieldName : labelText}
        value={index === '' ? this.props.Tier.PricingDetails[fieldName] : this.props.Tier.TierList[index][fieldName]}
        onChange={(fieldName, newValue) => this.InputFieldOnChange(fieldName, newValue, index)}
        type={type}
        validityChecker={validityCheckerFunction}
        selectValues={selectValues}
        disabled={disabled}
        dropDownValues={dropDownValues}
        className={inputClass}
        fieldType={fieldType}
        numberOfRows={6}
      />
    );
  }

  InputFieldOnChange(fieldName, newValue, index) {
    if (fieldName === 'NumEvalsPerCycle') {
      const validatedValue = this.validateMinimumValue(fieldName, newValue);

      if (typeof validatedValue !== 'number' || isNaN(validatedValue)) return;

      newValue = validatedValue;
      // Only allow numbers
    }

    if (index === '') this.props.onChangePricingDetail(fieldName, newValue);
    else this.props.onChange(fieldName, newValue, index);
  }

  validateMinimumValue(fieldName, newValue) {
    // Only positive integers for NumEvalsPerCycle
    if (fieldName === 'NumEvalsPerCycle' && (!/^\d+$/.test(newValue) || newValue === '')) {
      return NaN;
    }

    // Enforce minimum of 1 for NumEvalsPerCycle
    if (fieldName === 'NumEvalsPerCycle' && (newValue <= 0 || isNaN(newValue))) {
      return mathHelper.LimitMin(Number(newValue), 1);
    }
    return Number(newValue);
  }

  Editable() {
    return this.props.Tier.PricingDetails.PricingDetailId === '' || this.props.Tier.PricingDetails.Status === 'Final';
  }
}

export default BaseCard;
